import { createAction, createAsyncAction } from 'typesafe-actions';
import { LoyaltyMemberActivity } from './types';

const fetchLoyaltyMemberActivity = createAsyncAction(
  '@loyalty/memberActivity/fetch',
  '@loyalty/memberActivity/success',
  '@loyalty/memberActivity/error'
)<string, LoyaltyMemberActivity[], unknown>();

const setActivityMonth = createAction(
  '@loyalty/memberActivity/month/set',
  action => (period: string) => action(period)
);

export const loyaltyMemberActivityActions = {
  fetchLoyaltyMemberActivity,
  setActivityMonth
};
